import React, { useEffect, useState, useCallback } from "react";

import {
  Box,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Container,
  Grid,
  FormGroup,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { connect } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

import { handleInputMask } from "../../../utils/inputMasks";
import { isEmpty } from "../../../utils/objectManipulations";
import CheckBox from "../../Checkbox";
import Loading from "../../Loading";
import Button from "../Fields/Button";
import Field from "../Fields/Field";
import RoleField from "../Fields/RoleField";

import useStyles from "./styles";
import { handleInputValidation } from "../../../utils/inputValidations";
import DialogMessage from "../../Dialog";

const ManageUser = ({
  getUser,
  selectedUser,
  error,
  newUser,
  createUser,
  updateUser,
  getRelationByAddressNumber,
  getRelationByDocumentNumber,
  relatedAddresses,
  loading,
  clearRelation,
  clearFormErrors,
  saveManagerPermissions,
  updateTransporterPermissions,
  selectedId,
  user,
  clearNewUser,
  transportersAddresses,
  getRelatedTransporters,
  createTransporter,
  setValue,
  setValidation,
  updateSelectedUserField
}) => {
  const classes = useStyles();
  const { id } = useParams();
  const [search, setSearch] = useState("documentNumber");
  const [inputValue, setInputValue] = useState("");
  const [userCreated, setUserCreated] = useState(null);
  const history = useHistory();
  const oldUser = !!id;

  const handleChange = (event) => {
    setSearch(event.target.value);
  };

  const isTransporter = useCallback((group) => {
    return group && group?.indexOf("transporter") !== -1;
  }, []);

  const isClient = useCallback((group) => {
    return group && group?.indexOf("client") !== -1;
  }, []);

  const isFarmer = useCallback((group) => {
    return group && group?.indexOf("farmer") !== -1;
  }, []);

  const isAdmin = useCallback((group) => {
    return group && group?.indexOf("user_admin") !== -1;
  }, []);

  useEffect(() => {
    if (id) {
      getUser(id);
    }

    clearFormErrors();
    clearRelation();
  }, [getUser, id, clearRelation, clearFormErrors]);

  useEffect(() => {
    newUser.id && history.push(`editar-usuario/${newUser.id}`);
    newUser.id && getUser(newUser.id);
  }, [getUser, newUser.id, history]);

  useEffect(() => {
    if (!oldUser) {
      clearNewUser();
      if (isTransporter(user.groups) && isAdmin(user.groups)) {
        getRelatedTransporters({ userId: null, managerId: user.id });
      }
    }
  }, [
    clearNewUser,
    oldUser,
    isTransporter,
    isAdmin,
    getRelatedTransporters,
    user.groups,
    user.id,
  ]);

  useEffect(() => {
    oldUser &&
      isTransporter(user.groups) &&
      isAdmin(user.groups) &&
      getRelatedTransporters({ userId: parseInt(id), managerId: user.id });
  }, [
    getRelatedTransporters,
    oldUser,
    id,
    user.id,
    isAdmin,
    isTransporter,
    user.groups,
  ]);

  const onKeyDownHandler = e => {
    if (inputValue?.length >= 18) {
      if (e?.keyCode === 8) {
        setInputValue(inputValue?.substring(inputValue?.length - 2, 1));
      }
    }
  };

  async function hdlCreateUser() {
    if (isEmpty(error)) {
      setUserCreated( await createUser({ userSubType: ['client', 'vendor'].includes(newUser?.type.value) ? 'scheduler' : newUser?.userSubType }) )
    }
  }

  async function hdlUpdateUser() {
      await updateUser({ id });
  }

  return (
    <div className={classes.root}>
      {loading && <Loading />}
      <Container width="100%">
        <Box className={classes.container} height={400} marginTop={2}>
          <Box>
            <Grid container className={classes.firstRow}>
              <Grid item md={4} sm={12} xs={12}>
                <Field
                  isDisabled={oldUser}
                  label="Nome"
                  placeholder="Digite o nome do usuário"
                  isRequired
                  oldUser={oldUser}
                  fieldLength={128}
                  data-cy="manager-user-name-inp"
                  id="manager-user-name-inp"
                  attr="name"
                  selectedUser={selectedUser}
                />
              </Grid>
              <Grid item md={4} sm={12} xs={12}>
                <RoleField
                  isDisabled={oldUser}
                  oldUser={oldUser}
                  selectedUser={selectedUser}
                  user={user}
                />
              </Grid>
                <Grid item md={4} sm={12} xs={12}>
                  <Field
                    attr="email"
                    oldUser={oldUser}
                    data-cy="manager-user-email-inp"
                    id="manager-user-email-inp"
                    label="E-mail Okta"
                    placeholder="Digite o e-mail do usuário"
                    selectedUser={selectedUser}
                  />
                </Grid>
                <Grid item md={4} sm={12} xs={12}>
                  <Field
                    attr="contactEmail"
                    oldUser={oldUser}
                    isDisabled={false}
                    value={selectedUser["contactEmail"] }
                    inputValue={selectedUser["contactEmail"] } 
                    data-cy="manager-contact-email-inp"
                    id="manager-contact-email-inp"
                    label="Email para contato"
                    placeholder="Digite o email para contato"
                    selectedUser={selectedUser}
                    onChange={(e) => {
                      const value = e?.target?.value;
                      if(value) {
                        updateSelectedUserField({key: "contactEmail", value: value });
                        setValue({ key: "contactEmail", value: value });
                      }
                    }}
                    onInputChange={(inputValue, action) => {
                      if( action.action !== "input-blur" && action.action !== "menu-close" ) {
                          updateSelectedUserField({ key: "contactEmail", value: inputValue })
                          setValue({ key: "contactEmail", value: inputValue });
                        }
                      }
                    }
                  />
                </Grid>

                <Grid item md={4} sm={12} xs={12}>
                  <Field
                    attr="phone"
                    oldUser={ id ? oldUser : "false"}
                    isDisabled={false}
                    value={handleInputMask("phone",selectedUser["phone"])}
                    inputValue={handleInputMask("phone",selectedUser["phone"])}
                    data-cy="manager-phone-number-inp"
                    id="manager-phone-number-inp"
                    label="Telefone"
                    placeholder="Digite o telefone do usuário"
                    selectedUser={selectedUser}
                    onChange={(e) => {
                      const value = e?.target?.value;
                      if(value) {
                        const plain = inputValue.replace(/\D/g, '');

                        updateSelectedUserField({key: "phone", value: plain });
                        setValue({ key: "phone", value: plain });
                      }
                    }}
                    onInputChange={(inputValue, action) => {
                      if(action.action !== "input-blur" && action.action !== "menu-close") {
                        const plain = inputValue.replace(/\D/g, '');

                        updateSelectedUserField({ key: "phone", value: plain })
                        setValue({ key: "phone", value: plain });
                      }
                    }}
                  />
                </Grid>
            </Grid>
            {(newUser?.type?.value === "warehouse" || selectedUser?.type === "warehouse") && (
              <Grid item md={4} sm={12} xs={12}>
                <Field
                      isDisabled={oldUser}
                      label="Número da BP"
                      oldUser={oldUser}
                      attr="bpNumber"
                      data-cy="bp-inp"
                      id="bp-inp"
                      isRequired
                      //fieldLength={100}
                      placeholder="Digite o número da BP"
                      selectedUser={selectedUser}
                    />
              </Grid>
            )}
            {(newUser?.type?.value === "driver" ||
              selectedUser?.type === "driver") && (
                <Grid container className={classes.firstRow}>
                  <Grid item md={5} sm={12} xs={12}>
                    <Field
                      isDisabled={oldUser}
                      label="CNH"
                      oldUser={oldUser}
                      attr="driverLicense"
                      data-cy="manager-user-cnh-inp"
                      id="manager-user-cnh-inp"
                      isRequired
                      fieldLength={11}
                      placeholder="Digite o número da CNH"
                      selectedUser={selectedUser}
                    />
                  </Grid>
                  <Grid item md={4} sm={12} xs={12}>
                    <Field
                      isDisabled={oldUser}
                      label="Validade CNH"
                      oldUser={oldUser}
                      fieldLength={10}
                      isRequired
                      data-cy="manager-user-cnh-date-inp"
                      id="manager-user-cnh-date-inp"
                      attr="driverLicenseExpiration"
                      placeholder="Digite a data de validade da CNH"
                      selectedUser={selectedUser}
                    />
                  </Grid>
                  <Grid item md={4} sm={12} xs={12}>
                    <Field
                      isDisabled={oldUser}
                      label="Cartão Pedágio"
                      attr="tollNumber"
                      fieldLength={10}
                      isRequired={false}
                      oldUser={oldUser}
                      data-cy="manager-user-tollNumber-inp"
                      id="manager-user-tollNumber-inp"
                      placeholder={
                        !selectedUser?.tollNumber
                          ? "Digite o Cartão Pedágio"
                          : "Digite o código do Cartão Pedágio"
                      }
                      selectedUser={selectedUser}
                    />
                  </Grid>
                </Grid>
              )}
            {!oldUser && isAdmin(user?.groups) && (
              <Grid container className={classes.secondRow}>
                <Grid item sm={12} xs={12}>
                  <Button
                    label="Registrar"
                    icon="Add"
                    data-cy="manager-user-add-inp"
                    id="manager-user-add-inp"
                    className={classes.button}
                    onClick={hdlCreateUser}
                  />
                </Grid>
              </Grid>
            )}
            {oldUser && isAdmin(user?.groups) && (
              <Grid container className={classes.secondRow}>
                <Grid item sm={12} xs={12}>
                  <Button
                    label="Alterar"
                    icon="Add"
                    data-cy="manager-user-update-inp"
                    id="manager-user-update-inp"
                    className={classes.button}
                    onClick={hdlUpdateUser}
                  />
                </Grid>
              </Grid>
            )}
          </Box>
          {oldUser && (
            <>
              <Grid container className={classes.thirdRow}>
                {isAdmin(user?.groups) &&
                  !isTransporter(user?.groups) &&
                  (isClient(selectedUser?.groups) || isTransporter(selectedUser?.groups) || isFarmer(selectedUser?.groups)) && (
                    <>
                      <Grid>
                        <h2>Acesso{isAdmin()}</h2>
                      </Grid>
                      <Grid
                        item
                        md={12}
                        sm={12}
                        xs={12}
                        className={classes.comboGrid}
                      >
                        <Grid item md={2} sm={12} xs={12}>
                          <h4>Buscar address por:</h4>
                        </Grid>
                        <Grid
                          item
                          md={4}
                          sm={12}
                          xs={12}
                          className={classes.radio}
                        >
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="address"
                              row
                              data-cy="manager-user-address-rdo"
                              id="manager-user-address-rdo"
                              value={search}
                              onChange={handleChange}
                            >
                              <FormControlLabel
                                value="documentNumber"
                                data-cy="manager-user-document-rdo"
                                id="manager-user-document-rdo"
                                control={<Radio />}
                                label="CNPJ / CPF"
                              />
                              <FormControlLabel
                                value="address"
                                data-cy="manager-user-address-rdo"
                                id="manager-user-address-rdo"
                                control={<Radio />}
                                label="Address"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid
                          container
                          md={6}
                          sm={12}
                          xs={12}
                          className={classes.cnpj}
                        >
                          <Grid
                            container
                            flexDirection="row"
                            className={classes.cnpjInput}
                            md={6}
                            sm={12}
                            xs={12}
                          >
                            <Grid display="flex">
                              <TextField
                                placeholder={
                                  search === "address"
                                    ? "Digite o Address..."
                                    : "Digite apenas números"
                                }
                                value={inputValue.substr(0, 19)}
                                onKeyDown={onKeyDownHandler}
                                data-cy="manager-user-search-inp"
                                id="manager-user-search-inp"
                                size="small"
                                type="text"
                                variant="outlined"
                                className={classes.cnpjField}
                                onChange={(e) => {
                                  setInputValue(
                                    handleInputMask(search, e?.target?.value)
                                  );
                                  if (e.target.value) {
                                    setValue({
                                      key: "documentNumber",
                                      value: handleInputMask(
                                        search,
                                        e?.target?.value
                                      ),
                                    });
                                    setValidation({
                                      error: handleInputValidation(
                                        "documentNumber",
                                        handleInputMask(search, e?.target?.value)
                                      ),
                                      attr: "documentNumber",
                                    });
                                  }
                                }}
                              />
                            </Grid>
                            <span className={classes.error}>
                              {error && search === "documentNumber" && error["documentNumber"]}
                            </span>
                          </Grid>

                          <Button
                            onClick={() => {
                              if (search === 'address' && inputValue) {
                                getRelationByAddressNumber({ address: inputValue?.replace(/\s/g, ''), idUser: id, type: selectedUser?.type });
                                return;
                              }

                              // @todo validate cpf or cnpj
                              const isValidLengthCpfOrCnpj = inputValue?.length === 14 || inputValue?.length === 18;
                              if (isValidLengthCpfOrCnpj) {
                                getRelationByDocumentNumber({
                                  cnpj: inputValue,
                                  idUser: id,
                                  type: selectedUser?.type
                                });
                              }
                            }}
                            icon="search"
                            className={classes.userButton}
                            data-cy="manager-user-search-icon"
                            id="manager-user-search-icon"
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
              </Grid>
              <Grid container className={classes.forthRow}>
                <FormGroup>
                  <>
                    {relatedAddresses &&
                      relatedAddresses?.map((item, index) => (
                        <CheckBox key={item.id} item={item} />
                      ))}
                    {relatedAddresses?.length > 0 && (
                      <Button
                        onClick={() => {
                          saveManagerPermissions({
                            idUser: parseInt(id),
                            selectedId,
                            type: selectedUser?.type
                          });
                          setInputValue('');
                          history.goBack();
                        }}
                        label="SALVAR PERMISSÕES"
                        icon="save"
                        className={classes.saveButton}
                        data-cy="manager-user-save-permission-btn"
                        id="manager-user-save-permission-btn"
                      />
                    )}
                  </>
                </FormGroup>
              </Grid>
            </>
          )}
          {isAdmin(user?.groups) &&
            isTransporter(user?.groups) && (
              <Grid container className={classes.forthRow}>
                <FormGroup>
                  <>
                    {transportersAddresses &&
                      transportersAddresses?.map((item, index) => (
                        <CheckBox
                          key={item.id}
                          item={item}
                          selectedId={selectedId}
                          data-cy={`manager-user-check${item.id}`}
                          id={`manager-user-check${item.id}`}
                        />
                      ))}
                    {transportersAddresses?.length > 0 && (
                      <Button
                        onClick={() => {
                          if (oldUser && selectedId?.length > 0) {
                            updateTransporterPermissions({
                              idUser: parseInt(id),
                              selectedId: selectedId,
                              type: selectedUser?.type
                            });
                            history.goBack();
                          }
                          if (!oldUser && selectedId?.length > 0) {
                            createTransporter();
                          }
                        }}
                        label="SALVAR PERMISSÕES"
                        icon="save"
                        className={classes.saveButton}
                        data-cy="manager-user-save-permission-transporters-btn"
                        id="manager-user-save-permission-transporters-btn"
                      />
                    )}
                  </>
                </FormGroup>
              </Grid>
            )}
        </Box>
      </Container>

      <DialogMessage
        subject="Acesso de usuário preparado!"
        message="Este usuário recebeu uma notificação por e-mail para criar sua senha pessoal. Agora cadastre as permissões necessárias."
        isOpen={!!userCreated}
        data-cy="manager-user-prepare-modal"
        id="manager-user-prepare-modal"
        closeReadingNotificationDialog={() => {
          if (userCreated.type === 'transporter') {
            history.push(`/gerenciar-usuarios/editar-usuario/${userCreated.id}`);
          } else {
            history.push(`/gerenciar-usuarios/listar-usuarios`);
          }
          setUserCreated(null);
        }
      }
        setNoCache={() => {}}
      />
    </div>
  );
};

const mapState = (state) => ({
  relatedAddresses: state?.users?.permission.relatedAddresses,
  transportersAddresses: state?.transporters?.transporters,
  addressError: state?.users?.permission.error,
  selectedUser: state?.users?.selectedUser,
  newUser: state?.users?.newUser,
  error: state?.users?.formErrors,
  isOpen: state?.dialogs?.readingNotification.isOpen,
  loading: state?.users?.loading,
  selectedId: state?.users?.permission.selectedId,
  user: state?.auth?.user,
});

const mapDispatch = (dispatch) => ({
  getUser: (payload) => dispatch?.users?.getSelectedUserAsync(payload),
  createUser: (payload) => dispatch?.users?.createUserAsync(payload),
  updateUser: (payload) => dispatch?.users?.updateUserAsync(payload),
  getRelationByAddressNumber: (payload) => dispatch?.users?.getRelationByAddressNumber(payload),
  getRelationByDocumentNumber: (payload) => dispatch?.users?.getRelationByDocumentNumberAsync(payload),
  openDialog: (payload) =>
    dispatch?.dialogs?.openReadingNotificationDialog(payload),
  saveManagerPermissions: (payload) =>
    dispatch?.users?.saveManagerPermissionsAsync(payload),
  updateTransporterPermissions: (payload) =>
    dispatch?.users?.updateTransporterPermissionsAsync(payload),
  createTransporter: () => dispatch?.users?.createTransporterAsync(),
  clearSearch: (payload) => dispatch?.users?.clearRelationAsync(payload),
  clearFormErrors: (payload) => dispatch?.users?.clearFormErrors(payload),
  clearRelation: (payload) => dispatch?.users?.clearRelation(payload),
  clearNewUser: () => dispatch?.users?.clearNewUserAsync(),
  getRelatedTransporters: (payload) =>
    dispatch?.users?.getTransportersAsync(payload),
  setValue: (payload) => dispatch?.users?.setNewUserAsync(payload),
  updateSelectedUserField: (payload) => dispatch?.users?.updateSelectedUserField(payload),
  setValidation: (payload) => dispatch?.users?.setValidationAsync(payload),
});

export default connect(mapState, mapDispatch)(ManageUser);
